export default __webpack_public_path__ + "static/tessa2-6a1e18631e2c1b609c39340cc37779f9.jpg";